/**
 * Change this to `/events.csv` to use the locally hosted database in `public/`.
 * A full remote HTTPS URL and a root-relative local URL are both supported.
 */
export const EVENT_DATABASE_URL =
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vQMITJ-l4ChJl75ZxyMB5HcCehWmZJR5wlvoxBLbh1-j-XabkWt4nfe4eys0738ghJhjvv8Lb6Plp2b/pub?gid=856726960&single=true&output=csv';

export const CHANGE_LOG_URL =
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vQ5oPutHGlK-X_5TqRo23a7vQ_cuiY2a5Puq1VWP05it1tx5GCswVf1-VzlSMIYJ_sZOW0yCSIsZ5PN/pub?gid=84990677&single=true&output=csv';

export const NATIONAL_HOLIDAYS_URL =
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vQMITJ-l4ChJl75ZxyMB5HcCehWmZJR5wlvoxBLbh1-j-XabkWt4nfe4eys0738ghJhjvv8Lb6Plp2b/pub?gid=1397595879&single=true&output=csv';

export const EVENT_FORM_URL =
  'https://forms.gle/hLCHCVuGJUYgZDnRA';

export const BUG_REPORT_URL =
  'https://www.nms-agt.com/support';

